/* eslint-disable react/forbid-prop-types */
import React, { useState, useRef, useEffect } from 'react';
import Select from 'react-select';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import AdvBudgetChart from './AdvBudgetChart';
import { sortByAdvBudgetOptions } from '../../helper';

const AdvBudgetCompaignWise = ({ dir, data, title, viewReportButton }) => {


    const [selectedOptions, setSelectedOptions] = useState([]);
    const [sortBySelected, setSortBySelected] = useState(sortByAdvBudgetOptions[0])


    const changeFilter = (value) => {
        setSelectedOptions(value)
    };

    const dataByCampaign = {};

    data.forEach((item) => {
        if (item && dataByCampaign[item?.campaignName]) {
            dataByCampaign[item.campaignName]?.push(item)
        } else if (item) {
            if (!item?.campaignName || item?.campaignName === 'null') {
                if (dataByCampaign?.['N/A']) {
                    dataByCampaign['N/A']?.push(item)
                } else {
                    dataByCampaign['N/A'] = item
                }
            } else {
                dataByCampaign[item.campaignName] = [item]
            }
        }
    });

    const currentMCompaignCount = Object.keys(dataByCampaign);

    let dataToPlot = [];

    const options = []

    currentMCompaignCount.forEach((campaignName) => {
        const campaignNameWise = dataByCampaign[campaignName];

        let dailyBudgetAmount = 0;
        let costAmount = 0;
        let salesAmount = 0;

        campaignNameWise?.forEach((item) => {
            dailyBudgetAmount += Number(item.dailyBudget)
            costAmount += Number(item.cost);
            salesAmount += Number(item.sales)
        }
        );
        options.push({
            value: campaignName, label: campaignName
        })
        dataToPlot.push({
            title: campaignName,
            campaignNameWise,
            sales: salesAmount,
            cost: costAmount,
            dailyBudget: dailyBudgetAmount
        })
    })

    if (selectedOptions?.length) {
        const selected = selectedOptions?.reduce((acc, item) => {
            acc[item?.value] = item.value
            return acc
        }, {})
        dataToPlot = dataToPlot.filter(item => selected[item.title])
    }

    const sortBy = sortBySelected?.value;

    if (sortBy === 'title') {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy]?.toLowerCase() > b?.[sortBy]?.toLowerCase() ? 1 : -1)
    } else {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy] < b?.[sortBy] ? 1 : -1)
    }

    return (
        <Col xs="12">
            <CardBody>
                <Card className="pb-3 show-categ-daily-sales">
                    <div className="card__title row " style={{ position: 'relative' }}>
                        <h5 className="bold-text col-md-3">{title}</h5>
                        <div className="form__form-group mb-0 col-md-7" id='dvChartFilter'>
                            <div className="row justify-content-center align-items-center">
                                <div className="col-6">
                                    <span className="form__form-group-label font-weight-bold">
                                        Select Campaign</span>
                                    <div className="form__form-group-field">
                                        <Select
                                            value={selectedOptions}
                                            options={options}
                                            clearable={false}
                                            placeholder="Select Campaign"
                                            className="select_filter"
                                            onChange={changeFilter}
                                            classNamePrefix="react-select"
                                            isMulti
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <span className="form__form-group-label font-weight-bold">Sort By</span>
                                    <div className="form__form-group-field">
                                        <Select
                                            value={sortBySelected}
                                            options={sortByAdvBudgetOptions}
                                            clearable={false}
                                            placeholder="Sort By"
                                            className="select_filter"
                                            onChange={setSortBySelected}
                                            classNamePrefix="react-select"
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                    <CardBody >
                        <div id='dvChartView'>
                        {viewReportButton?.()}</div>
                        {dataToPlot?.length ? dataToPlot?.map((campaign, index) => (
                            <Row key={campaign.title}>
                                <Col sm={4} md={2}><CardText>{campaign.title}</CardText></Col>
                                <Col sm={8} md={10}>
                                    <AdvBudgetChart
                                        campaign={campaign}
                                        height={275}
                                        showTitle={false}
                                        dir={dir}
                                        index={index}
                                    />
                                </Col>
                            </Row>
                        )) : 'No data to display'}
                    </CardBody>

                </Card>
            </CardBody>
        </Col>

    )
}

AdvBudgetCompaignWise.propTypes = {
    dir: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
};

AdvBudgetCompaignWise.defaultProps = {
    title: 'Adv Budget Compaign Wise',
}

export default AdvBudgetCompaignWise;
